import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";
import api from "@/lib/api";
import { thumb } from "@/lib/img";

export default function DestinationWedding() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/settings/destination-wedding").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const cols = (d.columns || []).filter((c) => c.title);

  return (
    <section data-testid="destination-wedding" className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
      <div className="rounded-[28px] bg-white border border-[#ebe6e0] shadow-[0_20px_60px_-30px_rgba(41,39,36,0.25)] p-6 sm:p-10 lg:p-14">
        <div className="inline-flex items-center gap-2 rounded-full border border-[#ebe6e0] bg-white px-3 py-1 text-xs text-[#292724]"><MapPin className="w-3.5 h-3.5 text-[#d4af37]" /> {d.eyebrow}</div>
        <h2 data-testid="destination-wedding-title" className="font-serif text-xl sm:text-4xl lg:text-5xl leading-snug sm:leading-tight mt-3 sm:mt-4 text-[#292724]">{d.title}</h2>
        {d.subtitle && <p data-testid="destination-wedding-subtitle" className="mt-4 text-base md:text-lg text-[#8a837a] max-w-4xl leading-relaxed">{d.subtitle}</p>}
        <div className="border-t border-[#ebe6e0] my-8" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {cols.map((c, i) => (
            <Link key={`${c.title}-${i}`} to={c.link || "/venues"} data-testid={`destination-col-${i}`}
              className="group rounded-2xl bg-[#faf7f2] border border-[#ebe6e0] overflow-hidden hover:border-[#d4af37] hover:-translate-y-0.5 transition-[transform,border-color] duration-300">
              {c.image && (
                <div className="aspect-[16/10] overflow-hidden bg-[#f3efe9]">
                  <img src={thumb(c.image, 800)} alt={c.title} loading="lazy" className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105" />
                </div>
              )}
              <div className="p-6">
                <div className="flex items-start justify-between gap-2">
                  <h3 className="font-serif text-xl lg:text-2xl text-[#292724]">{c.title}</h3>
                  <ArrowUpRight className="w-4 h-4 text-[#d4af37] shrink-0 mt-1.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </div>
                {c.description && <p className="mt-2 text-sm text-[#8a837a] leading-relaxed">{c.description}</p>}
              </div>
            </Link>
          ))}
        </div>
      </div>

      <div className="flex justify-center pt-10">
        <Link to={d.button_link || "/venues"} data-testid="destination-wedding-btn" className="btn-gold text-base !px-10 !py-4">
          {d.button_label} <ArrowUpRight className="w-5 h-5" />
        </Link>
      </div>
    </section>
  );
}
